import React, { useCallback, useState } from 'react';

import type { ChatHistory } from '~/components/AiChat/controller/types';
import SearchIcon from '~/components/AiChat/icons/SearchIcon';
import { HistoryViewContainer } from '~/components/AiChat/SideBarDialog/components/HistoryView/HistoryViewContainer';
import CardDialog from '~/components/CardDialog';

interface SearchChatHistoryDialogProps {
  history: ChatHistory;
  open: boolean;
  onClose: () => void;
}

export const SearchChatHistoryDialog: React.FC<SearchChatHistoryDialogProps> = ({ history, open, onClose }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const { open: openChat } = history;

  const handleChatSelect = useCallback(
    async (chatId: string) => {
      await openChat(chatId);
      onClose();
    },
    [openChat, onClose]
  );

  const handleClose = useCallback(() => {
    setSearchQuery('');
    onClose();
  }, [onClose]);

  return (
    <CardDialog isDialog open={open} title="Search Chat" onClose={handleClose} maxWidth="sm" fullWidth>
      {/*Set to 60vh to prevent the dialog from shrinking when there are no results*/}
      <div className="flex h-[60vh] flex-col gap-16">
        <div className="mb-16 flex items-center gap-8 rounded-lg border border-solid border-blue-200 px-12 py-12">
          <input
            type="text"
            id="search-chat-history"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search Chat"
            className="flex-1 border-none bg-transparent text-sm outline-none placeholder:text-blue-200"
          />
          <SearchIcon size={14} className="text-slate-800" />
        </div>
        <HistoryViewContainer
          history={history}
          onChatSelect={handleChatSelect}
          searchQuery={searchQuery}
          onSearchQueryChange={setSearchQuery}
          showSearchField={false}
          showRename={false}
          containerClassName="p-0 h-full"
        />
      </div>
    </CardDialog>
  );
};
